import { useStore } from "effector-react";
import { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { $selectedAccountId } from "../../../common/accounts2";
import { $SiteColors } from "../../../common/config/company-atts";
import { pathLogin } from "../../../common/config/vars";
import { loggedIn } from "../../login/logics/reg";
import { $reconciliationActs, queryDownloadAct, queryGetActRequest, queryGetActs } from "../logic/getActs";
import { ActModal } from "../molecules/actModal";
import '../styles/acts.css'

export const ReconciliationAct = () => {
    const [modalText, setModalText] = useState<string>('')
    const [modalShow, setModalShow] = useState<boolean>(false)
    const allActs = useStore($reconciliationActs)
    useEffect(() => {
        queryGetActs($selectedAccountId.getState())
        // console.log($selectedAccountId.getState())
    }, [])

    const onDownloadClick = () => {
        queryGetActRequest($selectedAccountId.getState())
            .then((res) => {
                if (res) {
                    setModalText("Акт сверки создан")
                }
                else {
                    setModalText("Сегодня уже создавался акт сверки")
                }
                setModalShow(true)
                queryGetActs($selectedAccountId.getState())
            })
    }

    const onMonthDownloadClick = (actId: string, date: string) => {
        queryDownloadAct({actId:actId,date:date,accountId:$selectedAccountId.getState()})
    }
    return !loggedIn() ? ( // тут был !loggedIn()
        <Redirect to={pathLogin} />
    ) : (
        <section className="page__content page__content_overflow">
            <h1 className="page__title" style={{color:$SiteColors.getState().titleColor}}>Акты сверки</h1>
            <div className="page__data" style={{backgroundColor:$SiteColors.getState().cardBackgroundColor}}>
                <div className="page__data-card">
                    {allActs.length>0?
                    <>
                        <h2 className="acts_title">Получить акт сверки взаиморасчётов </h2>
                        {allActs.length>0&& allActs?.map((e,i)=>{
                            return (
                                <div className="acts_item_wrapper" key={i}>
                                    <p className="news-card__text">{i+1}. Акт сверки взаиморасчётов от {e.message}</p>
                                    <button
                                        type="button"
                                        className="payment__button"
                                        style={{ backgroundColor: $SiteColors.getState().backBtnSubmit }}
                                        onClick={()=>onMonthDownloadClick(e.pdfFile,e.message)}
                                        >                            
                                    Скачать
                                    </button>
                                </div> 
                            )
                        })}
                    </> : <h2 className="acts_title">Не выбран счет для акта сверки </h2> }
                    <button
                        type="button"
                        className="payment__button"
                        style={{ backgroundColor: $SiteColors.getState().backBtnSubmit }}
                        onClick={()=>onDownloadClick()}
                    >Заказать акт сверки</button>
                </div>
                {/* <AccountsBlock searchParams={searchParams}  setLookButtonIsClicked={setLookButtonIsClicked} />
        {accounts.length !== 0 && (
          <>
            <AccessControl intf={keyIntfCounters} ok={<CountersBlock />} />
            <AccessControl intf={keyIntfCharges} ok={<ChargesBlock lookButtonIsClicked={lookButtonIsClicked} setLookButtonIsClicked={setLookButtonIsClicked}/>} />
            <PaymentsBlock />
          </>
        )} */}
            </div>
            <ActModal show={modalShow} text={modalText} setShow={setModalShow}/>
        </section >
    );
}